export type DesktopProfileCardMetrics = {
  width: number;
  height: number;
  scale: number;
};

export function getDesktopProfileCardMetrics(
  profileCardCount: number,
  viewportWidth: number,
  viewportHeight: number,
): DesktopProfileCardMetrics {
  if (profileCardCount >= 6) {
    const height = Math.round(Math.min(Math.max(viewportHeight * 0.22, 188), 214));
    return {
      width: Math.round(height * (179 / 228)),
      height,
      scale: height / 228,
    };
  }

  const roomyGrid = profileCardCount <= 2;
  const widthRatio = roomyGrid ? 0.24 : profileCardCount <= 4 ? 0.215 : 0.195;
  const widthMin = roomyGrid ? 310 : profileCardCount <= 4 ? 280 : 248;
  const widthMax = roomyGrid ? 400 : profileCardCount <= 4 ? 340 : 310;
  const viewportBoost = roomyGrid ? Math.min(viewportWidth * 0.02, 56) : Math.min(viewportWidth * 0.012, 34);
  let width = Math.round(Math.min(Math.max(viewportWidth * widthRatio + viewportBoost, widthMin), widthMax));
  let height = Math.round(width * (228 / 179));

  // Limita a altura para evitar cortar em telas mais baixas
  const maxHeight = Math.round(viewportHeight * 0.44);
  if (height > maxHeight) {
    height = Math.max(maxHeight, 188);
    width = Math.round(height * (179 / 228));
  }

  return {
    width,
    height,
    scale: height / 228,
  };
}
